var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',_vm._b({ref:"multipleTable",on:{"selection-change":_vm.handleSelectionChange,"row-click":_vm.handleRowClick}},'el-table',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }